<template>
    <div class="container">
        <section class="section">
            <div class="offset-lg-1 offset-xl-2 col-lg-10 col-xl-8">
                <div class="steps-page"><span class="screen-reader-text">Steps 0 of 3</span>
                    <div class="steps-page__steps">
                        <div role="presentation" class="steps"><span aria-current="step" data-index-step="0"
                                                                     class="circle-step circle-step--active"></span><span
                                data-index-step="1" class="circle-step"></span><span data-index-step="2"
                                                                                     class="circle-step"></span>
                        </div>
                    </div>
                    <div class="steps-page__body">
                        <article class="mt-6 mb-5">
                            <div class="mb-4">
                                <svg viewBox="0 0 24 24" class="icon icon--40">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M5.29289 1.29289C5.68342 0.902369 6.31658 0.902369 6.70711 1.29289L8.70711 3.29289C9.09763 3.68342 9.09763 4.31658 8.70711 4.70711L6.70711 6.70711C6.31658 7.09763 5.68342 7.09763 5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289L5.55266 5.03313C4.10798 5.24911 3 6.49516 3 8C3 8.55228 2.55228 9 2 9C1.44772 9 1 8.55228 1 8C1 5.37273 3.02635 3.21874 5.60144 3.01565L5.29289 2.70711C4.90237 2.31658 4.90237 1.68342 5.29289 1.29289ZM9 8C9 4.13401 12.134 1 16 1C19.866 1 23 4.13401 23 8C23 11.866 19.866 15 16 15C15.6318 15 15.27 14.9715 14.9167 14.9165C14.9715 15.2697 15 15.6315 15 16C15 19.866 11.866 23 8 23C4.13401 23 1 19.866 1 16C1 12.134 4.13401 9 8 9C8.3685 9 8.73035 9.02848 9.08347 9.08334C9.02851 8.73002 9 8.36817 9 8ZM11.3551 9.85493C12.5308 10.4982 13.5018 11.4692 14.1451 12.6449C14.7176 12.8738 15.3431 13 16 13C18.7614 13 21 10.7614 21 8C21 5.23858 18.7614 3 16 3C13.2386 3 11 5.23858 11 8C11 8.65695 11.1262 9.28239 11.3551 9.85493ZM8 11C5.23858 11 3 13.2386 3 16C3 18.7614 5.23858 21 8 21C10.7614 21 13 18.7614 13 16C13 13.2386 10.7614 11 8 11ZM22 15C22.5523 15 23 15.4477 23 16C23 18.6273 20.9736 20.7813 18.3986 20.9843L18.7071 21.2929C19.0976 21.6834 19.0976 22.3166 18.7071 22.7071C18.3166 23.0976 17.6834 23.0976 17.2929 22.7071L15.2929 20.7071C14.9024 20.3166 14.9024 19.6834 15.2929 19.2929L17.2929 17.2929C17.6834 16.9024 18.3166 16.9024 18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071L18.4473 18.9669C19.892 18.7509 21 17.5048 21 16C21 15.4477 21.4477 15 22 15Z"></path>
                                </svg>
                            </div>
                            <h1>Become an Airtm cashier</h1><h5 class="font-weight--regular">Accept requests
                            from other Airtm users and help them complete transactions to receive fees for each
                            successful transaction.</h5></article>
                        <div class="row steps-page__navigation">
                            <div class="col-12 col-sm-6 col-md-4">
                                <button class="btn btn--secondary btn--block" type="button" data-loading="false"
                                        aria-expanded="false" id="skip-walkthrough">Skip
                                </button>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4">
                                <button class="btn btn--primary btn--block" type="button" data-loading="false"
                                        aria-expanded="false" id="next-step-walkthrough">Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "available",
    }
</script>

<style scoped>

</style>